module.exports = __webpack_public_path__ + "static/media/skibbereen.3781869b.jpg";